import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

const SimpleLink = ({
    href, children, target, onClick, disableAutoTracker, attributes, trackEvent, theme, to,
}) => {
    const navigate = useNavigate();

    return (
        <a
            { ...attributes }
            href={ href || to }
            target={ target }
            rel={ target === '_blank' ? 'noopener noreferrer' : null }
            data-internal={ !!to }
            data-disable-auto-tracker={ disableAutoTracker }
            className={ theme.root } // backward compatibility with externalLink
            onClick={ async (event, ...rest) => {
                if (trackEvent) {
                    event.preventDefault();
                    try {
                        await trackEvent();
                    } finally {
                        if (onClick) {
                            onClick(event, ...rest);
                        } else if (target === '_blank') {
                            window.open(href, target);
                        } else if (to) {
                            navigate(to);
                        } else {
                            window.location.assign(href);
                        }
                    }
                } else if (target === '_blank') {
                    window.open(href, target);
                } else if (onClick) {
                    event.preventDefault();
                    onClick(event, ...rest);
                } // 'a' tag default onClick event is handled by autoTracker
            } }
        >
            {children}
        </a>
    );
};

SimpleLink.propTypes = {
    attributes: PropTypes.shape({}),
    href: PropTypes.string,
    children: PropTypes.node.isRequired,
    disableAutoTracker: PropTypes.bool,
    trackEvent: PropTypes.func,
    target: PropTypes.oneOf(['_blank', '_self', '_parent', '_top']),
    onClick: PropTypes.func,
    theme: PropTypes.shape({}),
    to: PropTypes.string,
};

SimpleLink.defaultProps = {
    href: null,
    attributes: {},
    disableAutoTracker: false,
    target: undefined,
    onClick: undefined,
    theme: {},
    trackEvent: null,
    to: null,
};

export default SimpleLink;
